import { lazy } from "react";

// project imports
import GuestGuard from "../utils/route-guard/GuestGuard";
import MinimalLayout from "../layout/MinimalLayout";
import NavMotion from "../layout/NavMotion";
import Loadable from "../ui-component/Loadable";

// login routing
const AuthLogin = Loadable(
  lazy(() => import("../views/pages/authentication/Login3"))
);
const AuthForgotPassword = Loadable(
  lazy(() => import("../views/pages/authentication/ForgotPassword3"))
);
const AuthSetNewPassword = Loadable(
  lazy(() => import("../views/pages/authentication/SetNewPassword"))
);

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: "/",
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: "/",
      element: <AuthLogin />,
    },
    {
      path: "/login",
      element: <AuthLogin />,
    },
    {
      path: "/forgot",
      element: <AuthForgotPassword />,
    },
    {
      path: "/set-new-password/",
      element: <AuthSetNewPassword />,
    },
  ],
};

export default LoginRoutes;
